
import { defineComponent, shallowRef } from 'vue'

export default defineComponent({
  name: 'FileInput',
  props: {
    accept: {
      type: String,
      default: '*/*',
    },
    multiple: Boolean,
  },
  emits: ['input', 'change'],
  setup (props, ctx) {
    const file = shallowRef()

    const select = () => {
      if (file.value) {
        const input = file.value as HTMLInputElement
        input.value = ''
        input.click()
        ctx.emit('input')
      }
    }

    return {
      file,
      select,
    }
  },
})
